import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';
import {createWebEnhancedStyles} from '/util/webStyles.util';

export const styles = createWebEnhancedStyles({
  buttonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: alto,
    backgroundColor: white,
    width: '96%',
    marginLeft: indent * 1,
    marginBottom: indent * 1,
    borderRadius: indent * 0.5,
    flexDirection: 'row',
    minHeight: 42,
  },
  button: {
    marginVertical: indent * 0.6,
    paddingVertical: indent * 0.2,
  },
});
